<template>
  <div class="d-flex align-center flex-row">
    <div class="sort-by-arrows" @click="changeSortDirection">
      <img
        :class="['swap_vert_sorting', { rotated: sortDirection.includes('DESC'), resetRotate: sortDirection.includes('ASC') }]"
        :src="require('@/assets/icons/swap_vert.png')"
        alt="icone de troca de ordem"
        width="20"
        height="20"
      />
      <span v-if="!isMobile">Ordenar por</span>
    </div>
    <v-select
      v-model="selected"
      :items="items"
      dense
      flat
      solo
      hide-details
      append-icon="expand_more"
      background-color="cinza-l90"
      return-object
      :menu-props="{ offsetY: true }"
      style="width: 136px"
      @change="emitChanges"
    >
      <template #selection="{ item }">
        <span style="font-size: 14px; white-space: nowrap">{{ item.text }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'IndustryProposalSorting',
  data: () => ({
    selected: {
      text: 'Mais recentes',
      value: 'start_date',
    },
    sortDirection: ['ASC'],
  }),
  computed: {
    items() {
      return [
        {
          text: 'Mais recentes',
          value: 'start_date',
        },
        {
          text: 'Público alvo',
          value: 'target_audience',
        },
        {
          text: 'Indústria',
          value: 'industry.name',
        },
        {
          text: 'Mecânica',
          value: 'format',
        },
      ]
    },
  },
  methods: {
    changeSortDirection() {
      this.sortDirection = this.sortDirection.includes('DESC') ? ['ASC'] : ['DESC']
      this.emitChanges()
    },
    emitChanges() {
      this.$emit('change', { sortDirection: this.sortDirection, sortBy: this.selected.value })
    },
  },
}
</script>

<style lang="scss" scoped>
.sort-by-arrows {
  height: 38px;
  width: 132px;
  padding: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  border: 1px solid $cinza-l80;
  border-right: unset;
  border-radius: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: $marca-0-l20;
  user-select: none;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: $xs-breakpoint) {
    width: 34px;
  }
}

.swap_vert_sorting {
  transition: transform 0.5s ease;
}

.swap_vert_sorting.rotated {
  animation: bounceRotate 0.5s ease forwards;
}

.swap_vert_sorting.resetRotate {
  animation: bounceBack 0.5s ease forwards;
}

@keyframes bounceRotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(220deg);
  }
  70% {
    transform: rotate(160deg);
  }
  90% {
    transform: rotate(200deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes bounceBack {
  0% {
    transform: rotate(180deg);
  }
  50% {
    transform: rotate(-40deg);
  }
  70% {
    transform: rotate(10deg);
  }
  90% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
